import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const OrdersModule = lazy(loadModule);

export default OrdersModule;
